<app-topheader></app-topheader>
<div class="scrollingcontainer ">

    <div class="container">
        <div class="tenpxtop"></div>
        <app-current-date inputdate={{inputdate}}></app-current-date>
        <app-port-info inputdate={{inputdate}}></app-port-info>
        <div class="tenpxtop"></div>
        <app-port-description inputdate={{inputdate}}></app-port-description>
        <div class="tenpxtop"></div>

        <app-weatherforecast portcity={{portcity}} inputdate={{inputdate}}></app-weatherforecast>
        <div class="tenpxtop"></div>

    </div>
</div>
<app-bottommenu></app-bottommenu>